<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00002">
<h2 class="nobreak" id="ILLUSTRATIONS">ILLUSTRATIONS.</h2>
</div>
<table class="autotable1" summary="">
<tbody class="calibre10"><tr class="calibre11">
<td class="tdl"></td>
<td class="tdr1">PAGE</td>
</tr>
<tr class="calibre11">
<td class="tdl1">Persis was at that moment knitting her brows over some papers at a table in Annis’s little attic room</td>
<td class="tdr"><a href="#/Text/Section0002#frontis"><em class="calibre12">Frontispiece.</em></a></td>
</tr>
<tr class="calibre11">
<td class="tdl1">“Then, my dear, you are wearing your own great-great-grandmother’s gown”</td>
<td class="tdr"><span href="#/Text/Section0010#p084" title="Link target outside of Sample">84</span></td>
</tr>
<tr class="calibre11">
<td class="tdl1">“Please tell Mrs. Chamberlaine that Ruth is safe”</td>
<td class="tdr"><span href="#/Text/Section0015#p148" title="Link target outside of Sample">148</span></td>
</tr>
<tr class="calibre11">
<td class="tdl1">“This is Mary Carter’s grandchild”</td>
<td class="tdr"><span href="#/Text/Section0021#p212" title="Link target outside of Sample">212</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?efc8b33e